module.exports={
  backendurl:"https://research.nitt.edu/api/"
}
